import React from 'react';
import { PublicationWall } from './components/PublicationWall/PublicationWall';

export const PublicationWallApp: React.FC = () => {
  return <PublicationWall />;
};
